import { useCallback, useState } from 'react';

export default function useDialog(DialogComponent) {
  const [open, setOpen] = useState(false);

  // Memoize so the returned component keeps a stable identity across re-renders
  // (while `open` is unchanged). Without this, every parent re-render creates a
  // new component type, forcing React to unmount/remount the dialog — which
  // shows up as a flicker (e.g. during autosave in observer components).
  const Dialog = useCallback(
    (props) =>
      open ? (
        <DialogComponent {...props} open={open} setOpen={setOpen} />
      ) : null,
    [DialogComponent, open]
  );

  return [Dialog, setOpen, open];
}
